import Block from '../block'

export default class BlockGallery extends Block {
	static title = 'block-gallery'

	constructor($el) {
		super($el)

		const firstItem = this.$el.find(
			'sl-carousel-item.--in-view[data-index="1"]',
		)
		firstItem.addClass('--is-active')

		this.content = this.$el.findElement('content')

		this.initMasonryGrid()

		$(document).on('carousel:change-slide', (event, data) => {
			if (data.title && data.caption) {
				this.content.removeClass('hidden')
				if (this.$el.data('id') == data.id) {
					this.$el.findElement('title').text(data.title)
					this.$el.findElement('text').html(data.caption)
				}
			} else {
				this.content.addClass('hidden')
			}

			$(document).trigger('foldable:hide')
		})
	}

	initMasonryGrid() {
		this.$el.find('[data-masonry-list]').each((index, container) => {
			const shuffle = container.dataset.masonryShuffle !== 'false'
			let cols, gapPx, colHeights

			// Take columns and gaps from CSS
			const getVars = () => {
				const cs = getComputedStyle(container)
				cols = parseInt(cs.getPropertyValue('--masonry-col'))
				const rawGap = cs.getPropertyValue('--masonry-gap').trim()
				if (rawGap.endsWith('px')) {
					gapPx = parseFloat(rawGap)
				} else if (rawGap.endsWith('em')) {
					gapPx = parseFloat(rawGap) * parseFloat(cs.fontSize)
				} else if (rawGap.endsWith('rem')) {
					gapPx =
						parseFloat(rawGap) *
						parseFloat(getComputedStyle(document.documentElement).fontSize)
				} else {
					gapPx = parseFloat(rawGap)
				}
			}

			// Set the layout
			const layout = () => {
				getVars()
				const wCalc = `(100% - ${cols - 1}*var(--masonry-gap)) / ${cols}`
				colHeights = Array(cols).fill(0)
				container.style.position = 'relative'
				const items = Array.from(container.children)
				items.forEach((el) => {
					el.style.position = 'absolute'
					el.style.width = `calc(${wCalc})`
				})
				items.forEach((el, i) => {
					const h = el.offsetHeight
					// Columns within 5% of the item width count as level, so near-equal
					// heights (e.g. 466px vs 467px source images) still fill left to right
					const tolerance = el.offsetWidth * 0.05
					const minHeight = Math.min(...colHeights)
					const idx = shuffle
						? colHeights.findIndex(
								(colHeight) => colHeight - minHeight <= tolerance,
						  )
						: i % cols
					el.style.top = `${colHeights[idx]}px`
					el.style.left = `calc(${wCalc}*${idx} + var(--masonry-gap)*${idx})`
					colHeights[idx] += h + gapPx
				})
				container.style.height = `${Math.max(...colHeights)}px`
			}

			// Debounce function
			const debounce = (fn, delay) => {
				let t
				return () => {
					clearTimeout(t)
					t = setTimeout(fn, delay)
				}
			}

			// Resize handler
			const onResize = debounce(layout, 100)
			window.addEventListener('resize', onResize)

			// Watch for image loads (fallback if no aspect-ratio defined)
			const debouncedLayout = debounce(layout, 50)
			const imgLoad = () => {
				container.querySelectorAll('img').forEach((img) => {
					if (!img.complete) {
						img.addEventListener('load', debouncedLayout, { once: true })
						img.addEventListener('error', debouncedLayout, { once: true })
					}
				})
			}

			// Run layout immediately, then watch for straggler images
			layout()
			imgLoad()

			// Constructor with destroy and recalc function
			container._masonry = {
				recalc: () => {
					layout()
					imgLoad()
				},
				destroy: () => {
					window.removeEventListener('resize', onResize)
					const items = Array.from(container.children)
					items.forEach((el) => {
						el.style.position =
							el.style.width =
							el.style.top =
							el.style.left =
								''
					})
					container.style.position = container.style.height = ''
				},
			}
		})
	}
}
